import "./matchTimeline.sass";
import EventColumn from "./eventColums";
import { EventItem } from "./eventItem";
import MatchClockCounter from "./matchClockCounter";

export default function MatchTimeline({
  type = "minuto-a-minuto",
  events = [],
  homeTeamInfo = { name: "Equipo Local" },
  awayTeamInfo = { name: "Equipo Visitante" },
  homeTeamId = null,
  soccerData = null,
  period = "",
  clase = ""
}) {

  // Función para determinar si un evento es del equipo local
  // Si es auto gol (eventType === "OG"), se asigna al equipo contrario
  const isHomeTeamEvent = (event) => {
    const isOwnGoal = event.type === "goal" && event.eventType === "OG";
    // Si es OG, invertir: si fue marcado por "away" (id_visita), lo cuenta para "home"
    if (isOwnGoal) {
      return event.contestantId !== homeTeamId;
    }
    return event.contestantId === homeTeamId;
  };

  // Separar eventos por equipo y ordenar por minuto (una sola vez)
  const homeTeamEvents = events
    .filter(event => isHomeTeamEvent(event))
    .sort((a, b) => a.timeMin - b.timeMin);

  const awayTeamEvents = events
    .filter(event => !isHomeTeamEvent(event))
    .sort((a, b) => a.timeMin - b.timeMin);

  // Detectar eventos cercanos y agregar offset para evitar sobreposición
  // Mínimo de 3 minutos entre eventos para considerar que no se enciman
  const MIN_SPACING = 3; // minutos
  const addEventSpacing = (eventsList) => {
    return eventsList.map((event, index) => {
      let offset = 0;
      // Verificar si hay eventos cercanos
      for (let i = index - 1; i >= 0; i--) {
        if (eventsList[index].timeMin - eventsList[i].timeMin < MIN_SPACING) {
          offset += 1;
        } else {
          break;
        }
      }
      return { ...event, offset };
    });
  };

  const homeTeamEventsWithOffset = addEventSpacing(homeTeamEvents);
  const awayTeamEventsWithOffset = addEventSpacing(awayTeamEvents);

  // Vista de Partido: Dos columnas
  if (type === "partido") {
    return (
      <div className="match-timeline-container match-timeline-container--partido">
        <EventColumn teamEvents={homeTeamEvents} teamInfo={homeTeamInfo} isHome={true} />
        <div className="timeline-divider" />
        <EventColumn teamEvents={awayTeamEvents} teamInfo={awayTeamInfo} isHome={false} />
      </div>
    );
  }

  // Vista de Minuto a Minuto: Línea de tiempo horizontal
  if (type === "minuto-a-minuto") {
    return (
      <div className="match-timeline-container match-timeline-container--minuto-a-minuto">
        {/* Contador del reloj al final de la línea */}
        <div className="timeline-clock-wrapper">
          <MatchClockCounter
            soccerData={soccerData}
            periodTitle={period}
            className="timeline-clock"
            clase={clase}
          />
        </div>

        <div className="timeline-team-label timeline-team-label--home">
          <img src={homeTeamInfo.logo} alt={homeTeamInfo.name}></img>
        </div>

        <div className="timeline-events-top">
          <div className="timeline-track-wrapper">
            {homeTeamEventsWithOffset.map((event, index) => (
              <EventItem key={`home-${event.timeMin}-${index}`} event={event} side="home" />
            ))}
          </div>
        </div>

        <div className="timeline-horizontal">
          <div className="timeline-line" />
          <div className="timeline-marks">
            {[0, 45, 90].map((min) => (
              <div key={min} className="timeline-mark" style={{ left: `${(min / 90) * 100}%` }}>
                <span>{min}'</span>
              </div>
            ))}
          </div>

        </div>

        <div className="timeline-events-bottom">
          <div className="timeline-track-wrapper">
            {awayTeamEventsWithOffset.map((event, index) => (
              <EventItem key={`away-${event.timeMin}-${index}`} event={event} side="away" />
            ))}
          </div>
        </div>

        <div className="timeline-team-label timeline-team-label--away">
          <img src={awayTeamInfo.logo} alt={awayTeamInfo.name}></img>
        </div>
      </div>
    );
  }

  return null;
}
